import axios from "axios";
// import { Message } from "element-ui";

export function request(config){
  return new Promise((resolve, reject) => {
    // 1.创建axios的实例
    const instance = axios.create({
      withCredentials: true,
      baseURL: '/api',
      // timeout: 5000,
    })
    // 响应拦截
    instance.interceptors.response.use(response => {
      // console.log(response)
      if(response.data.code === 1000){
        if(response.config.url === '/user/userInfo' || response.config.url === '/tryLogin.action' || response.config.url === '/product/addProduct'|| response.config.url === '/product/getSales'){
          return response;
        }
        else {
          location.reload();
        }
      }else{
        return response
      }
    },error => {
      // Message.error('url:' + config.url + `\r\n` + error)
      reject(error)
    })
    // 发送真正的网络请求
    instance(config).then( res => {
      resolve(res)
    }).catch( err => {
      reject(err)
    })
  })
}
